const PARAMETER_MAP = {
    "Di&oacute;xido de azufre": "Dióxido de Azufre",
    "Di&oacute;xido de nitr&oacute;geno": "Dióxido de Nitrógeno",
    "Mon&oacute;xido de carbono": "Monóxido de Carbono",
};

const HTML_ENTITIES = {
    '&aacute;': 'á', '&eacute;': 'é', '&iacute;': 'í',
    '&oacute;': 'ó', '&uacute;': 'ú', '&ntilde;': 'ñ',
    '&Aacute;': 'Á', '&Eacute;': 'É', '&Iacute;': 'Í',
    '&Oacute;': 'Ó', '&Uacute;': 'Ú', '&Ntilde;': 'Ñ',
};

export const parameterTextConverter = (parameterText) => {
    if (!parameterText) return '';
    return PARAMETER_MAP[parameterText] ??
        parameterText.replace(/&[a-zA-Z]+;/g, entity => HTML_ENTITIES[entity] ?? entity);
};

export default parameterTextConverter;
